type Row = Record<string, unknown>;
export interface WeaponSkillReaders {
    value: (row: Row | null, key: string) => unknown;
    entries: (row: Row | null, key: string) => unknown[];
}
const upper = (value: unknown): string => String(value ?? '').trim().toUpperCase();

/** Shared by the roll and its previews. Owner 2026-10-11: every throw uses Throwable Weapon Skill. */
export function weaponAttackSkill(weapon: Row, caster: Row, read: WeaponSkillReaders, throwing = false): string {
    if (throwing || read.entries(weapon, 'attack_ability_throws_the_throwing_weapon_at_target').length) return 'throwable_weapon_skill';
    const type = upper(read.value(weapon, 'weapon_type'));
    if (type !== '1364260D-E37C-4257-AD16-5E745107811A') {
        return upper(read.value(weapon, 'weapon_category')) === '82A55683-3171-458E-ABCC-27739151D606' ? 'firearms_weapon_skill' : 'archery_weapon_skill';
    }
    const classification = upper(read.value(weapon, 'weapon_classification'));
    const natural = ['NATURAL_WEAPON', 'AB7DEAAE-62BF-4996-A510-5F2B192F8F14', 'F187EE82-1D32-4C53-9F69-E59DDF33D7C7'].includes(classification);
    const twoHanded = read.entries(weapon, 'weapon_two_handed').length > 0 || Number(read.value(caster, 'count_both_hands_weapon_equipped') ?? 0) === 1;
    const fist = classification === 'F187EE82-1D32-4C53-9F69-E59DDF33D7C7';
    return natural && !fist ? 'natural_weapon_skill' : twoHanded ? 'two_handed_melee_weapon_skill' : fist ? 'natural_weapon_skill' : 'one_handed_melee_weapon_skill';
}
